import React from 'react';
import { ChevronDown, Github, Linkedin, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ data }) => {
  const scrollToNext = () => {
    const aboutSection = document.querySelector('#about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1606606767399-01e271823a2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NTg0NzI5ODh8MA&ixlib=rb-4.1.0&q=85')`
        }}
      >
        <div className="absolute inset-0 bg-slate-900/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          {/* Main Heading */}
          <div className="space-y-4">
            <h1
  className="text-5xl md:text-7xl font-bold text-white leading-tight"
  style={{
    animation: "blink 3s steps(1, end) infinite",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }}
>
  Hi, I'm{" "}
  <span className="bg-gradient-to-r from-emerald-400 via-blue-400 to-purple-600 bg-clip-text text-transparent">
    Gargi Sahu
  </span>
</h1>

            <p className="text-xl md:text-2xl text-slate-300 font-medium">
              {data.tagline}
            </p>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
            {data.description}
          </p>

          {/* Social Links */}
          <div className="flex justify-center space-x-6">
            <a
              href={data.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-slate-800/50 rounded-full text-slate-300 hover:text-emerald-400 hover:bg-slate-700/50 transition-all duration-200 hover:scale-110"
            >
              <Github size={24} />
            </a>
            <a
              href={data.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-slate-800/50 rounded-full text-slate-300 hover:text-blue-400 hover:bg-slate-700/50 transition-all duration-200 hover:scale-110"
            >
              <Linkedin size={24} />
            </a>
            <a
              href={`mailto:${data.social.email}`}
              className="p-3 bg-slate-800/50 rounded-full text-slate-300 hover:text-purple-400 hover:bg-slate-700/50 transition-all duration-200 hover:scale-110"
            >
              <Mail size={24} />
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={() => scrollToNext()}
              className="bg-gradient-to-r from-emerald-500 to-blue-600 hover:from-emerald-600 hover:to-blue-700 text-white px-8 py-3 text-lg font-medium transition-all duration-200 hover:scale-105"
            >
              Explore My Work
            </Button>
            <Button
              variant="outline"
              className="border-emerald-400 text-emerald-400 hover:bg-emerald-400 hover:text-slate-900 px-8 py-3 text-lg font-medium transition-all duration-200 hover:scale-105"
              onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Get In Touch
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-slate-400 hover:text-emerald-400 transition-colors duration-200 animate-bounce"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;